__turbopack_context__.v({
  "actions": "vFjbda_actions",
  "body": "vFjbda_body",
  "button": "vFjbda_button",
  "heading": "vFjbda_heading",
  "message": "vFjbda_message",
});
